import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=bda4a070&scoped=true&lang=html&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda4a070",
  null
  
)

export default component.exports